{
  "COMPOSE_REDIRECT": {
    "OPENING": "Öppnar en ny konversation med {email}…",
    "NO_EMAIL": "Ingen e-postadress angavs. Använd ?email=name@example.com",
    "CONTACT_ERROR": "Det gick inte att hitta kontakten för {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Välj en konversation från vänster panel",
    "CSAT_REPLY_MESSAGE": "Betygsätt konversationen",
    "404": "Tyvärr kan vi inte hitta konversationen. Försök igen",
    "SWITCH_VIEW_LAYOUT": "Byt layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Meddelanden",
    "UNVERIFIED_SESSION": "Identiteten för den här användaren är inte verifierad",
    "NO_MESSAGE_1": "Oj då! Det ser ut som att det inte finns några meddelanden från kunder i din inkorg.",
    "NO_MESSAGE_2": " för att skicka ett meddelande till din sida!",
    "NO_INBOX_1": "Hola! Ser ut som om du inte har lagt till några inkorgar än.",
    "NO_INBOX_2": " för att komma igång",
    "NO_INBOX_AGENT": "Oj då! Ser ut som om du inte är del av någon inkorg. Kontakta administratören",
    "SEARCH_MESSAGES": "Sök meddelanden i konversationer",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Översättning",
    "EMPTY_STATE": {
      "CMD_BAR": "för att öppna kommandomenyn",
      "KEYBOARD_SHORTCUTS": "för att visa kortkommandon"
    },
    "SEARCH": {
      "TITLE": "Sök meddelanden",
      "RESULT_TITLE": "Sökresultat",
      "LOADING_MESSAGE": "Tuggar data...",
      "PLACEHOLDER": "Skriv valfri text för att söka efter meddelanden",
      "NO_MATCHING_RESULTS": "Inga resultat hittades."
    },
    "UNREAD_MESSAGES": "Olästa meddelanden",
    "UNREAD_MESSAGE": "Oläst meddelande",
    "CLICK_HERE": "Klicka här",
    "LOADING_INBOXES": "Laddar inkorgar",
    "LOADING_CONVERSATIONS": "Laddar konversationer",
    "CANNOT_REPLY": "Du kan inte svara på grund av",
    "24_HOURS_WINDOW": "24 timmars meddelandebegränsning",
    "NOT_ASSIGNED_TO_YOU": "Den här konversationen är inte tilldelad dig. Vill du tilldela dig själv den här konversationen?",
    "ASSIGN_TO_ME": "Tilldela mig",
    "TWILIO_WHATSAPP_CAN_REPLY": "Du kan bara svara på denna konversation med ett mallmeddelande på grund av",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 timmars meddelandebegränsning",
    "REPLYING_TO": "Du svarar:",
    "REMOVE_SELECTION": "Ta bort urval",
    "DOWNLOAD": "Hämta",
    "UNKNOWN_FILE_TYPE": "Okänd fil",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Gör detta innan du skickar:",
      "EXECUTE": "Utför",
      "RETRY": "Försök igen",
      "CONFIRM": "Utför nu?",
      "CONFIRM_YES": "Ja, utför",
      "CONFIRM_NO": "Avbryt",
      "RUNNING": "Utförs…",
      "DONE": "Utförd",
      "CLAIM_DELAYED": "registreras när beställningen har levererats",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "En NY reklamation {reference} har registrerats, {planned} är stängd — redigera utkastets text",
        "NEW_CLAIM": "En NY reklamation {reference} har registrerats i stället för att {planned} uppdaterades — redigera utkastets text",
        "OTHER_CLAIM": "Reklamation {reference} har uppdaterats i stället för {planned} — redigera utkastets text",
        "EXISTING_CLAIM": "Ingen ny reklamation registrerades, den befintliga {reference} har uppdaterats — redigera utkastets text",
        "OTHER": "Det gick annorlunda än utkastet förutsatte — redigera utkastets text"
      },
      "FAILED": "Misslyckades",
      "UNREACHABLE": "Boten kunde inte nås",
      "REQUEST_FAILED": "Åtgärden kunde inte startas, försök igen.",
      "ACTIONS": {
        "CANCEL_ORDER": "Avbryt beställningen",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Ändra betalningen till postförskott",
        "CREATE_CLAIM": "Registrera en reklamation",
        "CREATE_OR_UPDATE_CLAIM": "Registrera eller uppdatera en reklamation",
        "EXTEND_ORDER_PICKUP_DATE": "Förläng upphämtningstiden"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Laddar upp bilagor...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Detta meddelande stöds inte. Du kan se detta meddelande på Facebook Messenger-appen.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Detta meddelande stöds inte. Du kan se detta meddelande på Instagram-appen.",
    "SUCCESS_DELETE_MESSAGE": "Meddelandet har tagits bort",
    "FAIL_DELETE_MESSSAGE": "Det gick inte att ta bort meddelande! Försök igen",
    "NO_RESPONSE": "Inget svar",
    "RESPONSE": "Response",
    "RATING_TITLE": "Betyg",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Meddelandet är inte tillgängligt",
    "CARD": {
      "SHOW_LABELS": "Visa etiketter",
      "HIDE_LABELS": "Dölj etiketter"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Lös",
      "REOPEN_ACTION": "Återöppna",
      "OPEN_ACTION": "Öppna",
      "OPEN": "Mer",
      "CLOSE": "Stäng",
      "DETAILS": "detaljer",
      "SNOOZED_UNTIL": "Snoozad till",
      "SNOOZED_UNTIL_TOMORROW": "Snoozad till imorgon",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozad till nästa vecka",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozad till nästa svar",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Markera som väntande",
      "SNOOZE_UNTIL": "Snooza",
      "SNOOZE": {
        "TITLE": "Snooza tills",
        "NEXT_REPLY": "Nästa svar",
        "TOMORROW": "Imorgon",
        "NEXT_WEEK": "Nästa vecka"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooza tills",
      "APPLY": "Snooza",
      "CANCEL": "Avbryt"
    },
    "PRIORITY": {
      "TITLE": "Prioritet",
      "OPTIONS": {
        "NONE": "Inget",
        "URGENT": "Brådskande",
        "HIGH": "Hög",
        "MEDIUM": "Medel",
        "LOW": "Låg"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Inget",
        "INPUT_PLACEHOLDER": "Välj prioritet",
        "NO_RESULTS": "Inga resultat hittades",
        "SUCCESSFUL": "Ändrad prioritet för konversations-id {conversationId} till {priority}",
        "FAILED": "Kunde inte ändra prioritet. Försök igen."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Öppna i ny flik",
      "COPY_LINK": "Kopiera länk till konversationen",
      "COPY_LINK_SUCCESS": "Länken till konversationen har kopierats till urklipp",
      "PENDING": "Markera som väntande",
      "RESOLVED": "Markera som löst",
      "MARK_AS_UNREAD": "Markera som oläst",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Återöppna konversationen",
      "SNOOZE": {
        "TITLE": "Snooza",
        "NEXT_REPLY": "Tills nästa svar",
        "TOMORROW": "Tills imorgon",
        "NEXT_WEEK": "Tills nästa vecka"
      },
      "ASSIGN_AGENT": "Tilldela agent",
      "ASSIGN_LABEL": "Tilldela etikett",
      "AGENTS_LOADING": "Laddar agenter...",
      "ASSIGN_TEAM": "Tilldela team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Meddelandesignatur",
      "ENABLE_SIGN_TOOLTIP": "Aktivera signatur",
      "DISABLE_SIGN_TOOLTIP": "Inaktivera signatur",
      "MSG_INPUT": "Skift + Enter för ny rad. Börja med '/' för att välja en svarsmall.",
      "PRIVATE_MSG_INPUT": "Skift + Enter för ny rad. Detta kommer endast att vara synligt för agenter",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Meddelandesignaturen är inte konfigurerad. Konfigurera den i profilinställningarna.",
      "CLICK_HERE": "Klicka här för att uppdatera",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "WhatsApp-fönstret på 24 timmar har löpt ut. Svara med en mall.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Ditt svar verkar vara på {draftLanguage}, men den här konversationen är på {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Översätt",
      "REPLY": "Svara",
      "PRIVATE_NOTE": "Privat anteckning",
      "SEND": "Skicka",
      "CREATE": "Lägg till anteckning",
      "INSERT_READ_MORE": "Läs mer",
      "DISMISS_REPLY": "Avvisa svar",
      "REPLYING_TO": "Svarar till:",
      "TIP_FORMAT_ICON": "Visa textformaterare",
      "HEADING_LEVEL": {
        "LABEL": "Textstil",
        "NORMAL": "Normal text",
        "H1": "Rubrik 1",
        "H2": "Rubrik 2",
        "H3": "Rubrik 3"
      },
      "EDITOR": {
        "BOLD": "Fet",
        "ITALIC": "Kursiv",
        "UNDERLINE": "Understruken",
        "TEXT_COLOR": "Textfärg",
        "BG_COLOR_LABEL": "Bakgrundsfärg",
        "FONT_SIZE_LABEL": "Teckenstorlek",
        "FONT_SIZE": {
          "XS": "Liten",
          "SM": "Medelliten",
          "MD": "Standard",
          "LG": "Stor",
          "XL": "Extra stor",
          "XXL": "Enorm"
        },
        "CODE": "Kod",
        "LINK": "Lägg till eller ta bort länk",
        "CREATE_LINK": "Skapa länk",
        "SAVE_LINK": "Spara",
        "CANCEL": "Avbryt",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Ångra",
        "REDO": "Gör om",
        "BULLET_LIST": "Punktlista",
        "ORDERED_LIST": "Numrerad lista",
        "BLOCKQUOTE": "Citat",
        "H1": "Rubrik 1",
        "H2": "Rubrik 2",
        "H3": "Rubrik 3",
        "IMAGE_UPLOAD": "Ladda upp bild",
        "CLEAR_FORMATTING": "Rensa formatering",
        "COLOR": {
          "RED": "Röd",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Rosenröd",
          "DEEP_CYAN": "Mörk cyan",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistagegrön",
          "PURPLE": "Lila",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Silver",
          "NAVY": "Marinblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Turkos",
          "BROWN": "Brun",
          "OLIVE": "Oliv",
          "GOLD": "Guld",
          "BEIGE": "Beige",
          "WINE": "Vinröd",
          "FOREST": "Skogsgrön",
          "GREEN": "Grön",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinröd",
          "CHESTNUT_BROWN": "Kastanjebrun",
          "ASH_GREY": "Askgrå"
        },
        "BG_COLOR": {
          "RED": "Röd",
          "YELLOW": "Gul",
          "BLUE": "Blå",
          "ROSE_RED": "Rosenröd",
          "DEEP_CYAN": "Mörk cyan",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistagegrön",
          "PURPLE": "Lila",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Silver",
          "NAVY": "Marinblå",
          "OLD_PINK": "Gammelrosa",
          "AQUA": "Turkos",
          "BROWN": "Brun",
          "OLIVE": "Oliv",
          "GOLD": "Guld",
          "BEIGE": "Beige",
          "WINE": "Vinröd",
          "FOREST": "Skogsgrön",
          "GREEN": "Grön",
          "BLUE_GREY": "Blågrå",
          "RUBY_RED": "Rubinröd",
          "CHESTNUT_BROWN": "Kastanjebrun",
          "ASH_GREY": "Askgrå"
        }
      },
      "TIP_EMOJI_ICON": "Visa emoji-väljare",
      "TIP_ATTACH_ICON": "Bifoga filer",
      "TIP_AUDIORECORDER_ICON": "Spela in ljud",
      "TIP_AUDIORECORDER_PERMISSION": "Tillåt åtkomst till ljud",
      "TIP_AUDIORECORDER_ERROR": "Kunde inte öppna ljudet",
      "DRAG_DROP": "Dra och släpp hit för att bifoga",
      "START_AUDIO_RECORDING": "Starta ljudinspelning",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Lägg till bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-post separerade med kommatecken",
          "ERROR": "Ange giltiga e-postadresser"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-post separerade med kommatecken",
          "ERROR": "Ange giltiga e-postadresser"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Skicka",
          "CANCEL": "Avbryt"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Lägg till en SMS-inkorg för att skicka SMS-svar.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privat anteckning: Endast synlig för dig och ditt team",
    "CHANGE_STATUS": "Konversationsstatus ändrad",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Konversationstilldelning ändrad",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Konversationsteamet har ändrats",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Det gick inte att skicka detta meddelande, försök igen senare",
    "SENT_BY": "Skickat av:",
    "BOT": "Bot",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Välj agent",
      "REMOVE": "Radera",
      "ASSIGN": "Tilldela"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiera",
      "REPLY_TO": "Svara på detta meddelande",
      "DELETE": "Radera",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Radera",
        "CANCEL": "Avbryt"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Konversationen har markerats som löst av {userName}",
          "CONTACT_RESOLVED": "Conversation was resolved by {contactName}",
          "OPEN": "Konversationen öppnades igen av {userName}",
          "PENDING": "Conversation was marked as pending by {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Konversationen har markerats som löst av systemet på grund av {duration} dagars inaktivitet",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Systemet löste konversationen eftersom ärendet stängdes på Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} har tilldelat sig denna konversation",
          "ASSIGNED": "Tilldelad till {assigneeName} av {userName}",
          "REMOVED": "Konversation otilldelad av {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assigned to {teamName} by {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assigned to {assigneeName} via {teamName} by {userName}",
          "REMOVED": "Unassigned from {teamName} by {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} har lagt till {labels}",
          "REMOVED": "{userName} tog bort {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} har tystat konversationen",
        "UNMUTED": "{userName} har avtystat konversationen",
        "CONTACT_BLOCKED": "{userName} blockerade kontakten",
        "CONTACT_UNBLOCKED": "{userName} avblockerade kontakten",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Flyttad eftersom kontaktens beställningar bara kommer från butiken {storeName} (senaste beställning {orderId}), vars robot svarar i den här inkorgen.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatiseringen hoppades över eftersom kontakten är blockerad",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatiseringen \"{ruleName}\" kunde inte flytta den här konversationen från inkorgen {sourceInboxName} till inkorgen {targetInboxName} eftersom inkorgarna inte är kompatibla.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunde inte flytta den här konversationen från inkorgen {sourceInboxName} till inkorgen {targetInboxName} eftersom kontakten saknar e-postadress.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automationen \"{ruleName}\" kunde inte skicka ett meddelande: den här telefoninkorgen kan inte skicka SMS eftersom kontot inte har någon SMS-inkorg. Regeln stängdes av och administratörerna fick ett e-postmeddelande.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automationen \"{ruleName}\" kunde inte skicka ett meddelande: bilagor kan inte skickas som SMS från den här inkorgen. Regeln stängdes av och administratörerna fick ett e-postmeddelande.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macrot \"{macroName}\" skickade inte sitt meddelande: den här telefoninkorgen kan inte skicka SMS eftersom kontot inte har någon SMS-inkorg.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macrot \"{macroName}\" skickade inte sitt meddelande: bilagor kan inte skickas som SMS från den här inkorgen.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macrot \"{macroName}\" skickade inte sitt meddelande: boten hanterar den här konversationen. Öppna konversationen först.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macrot \"{macroName}\" skickade inte sitt meddelande: den här inkorgen är markerad för radering. Flytta först konversationen till en annan inkorg.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatiseringen \"{ruleName}\" skickade ett e-postmeddelande till {contactEmail} i en ny konversation [#{conversationId}]({conversationPath}) i inkorgen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatiseringen \"{ruleName}\" startade den här konversationen på grund av konversationen [#{conversationId}]({conversationPath}) i inkorgen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatiseringen \"{ruleName}\" kunde inte skicka meddelandet i en ny konversation i inkorgen {inboxName} eftersom kontakten saknar e-postadress.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatiseringen \"{ruleName}\" skickade ett SMS till {contactPhone} i en ny konversation [#{conversationId}]({conversationPath}) i inkorgen {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatiseringen \"{ruleName}\" kunde inte skicka SMS:et i en ny konversation i inkorgen {inboxName} eftersom kontakten saknar telefonnummer.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Kund"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "besvarat på annan telefon, ringde i {duration}",
            "NO_ANSWER": "obesvarat, ringde i {duration}",
            "REJECTED": "avvisat efter att ha ringt i {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Löst automatiskt efter antal misslyckade återuppringningar: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Samtalsinspelningen raderades av {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Osynlig för kunden",
    "SENT_VIA_EMAIL": "Skickades även till kontakten via e-post ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Den här inkorgen är markerad för radering, så kundens svar skulle aldrig komma fram. Flytta konversationen till en annan inkorg för att svara.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Den här kontakten har en annan öppen konversation #{id}",
      "MULTIPLE": "Den här kontakten har andra öppna konversationer ({count})",
      "OPEN": "Öppna",
      "SHOW": "Visa"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Be kunden dela sitt WhatsApp-telefonnummer",
      "PENDING_ACTION": "Förfrågan om kontaktinformation väntar",
      "STATES": {
        "PENDING": "Väntar på kontaktinformation",
        "SHARED": "Telefonnummer delat",
        "IDENTITY_CONFLICT": "Telefonnummer behöver granskas"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Skicka konversationstranskribering",
    "DESC": "Skicka en kopia av konversationstranskriberingen till den angivna e-postadressen",
    "SUBMIT": "Skicka",
    "CANCEL": "Avbryt",
    "SEND_EMAIL_SUCCESS": "Chattranskriberingen har skickats",
    "SEND_EMAIL_ERROR": "Ett fel uppstod, vänligen försök igen",
    "FORM": {
      "SEND_TO_CONTACT": "Skicka transkriberingen till kunden",
      "SEND_TO_AGENT": "Skicka transkriberingen till den tilldelade agenten",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Skicka transkriberingen till annan epost-adress",
      "EMAIL": {
        "PLACEHOLDER": "Ange en e-postadress",
        "ERROR": "Ange en giltig e-postadress"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hej 👋, Välkommen till {installationName}!",
    "DESCRIPTION": "Tack för att du registrerar dig. Vi vill att du ska få ut det mesta av {installationName}. Här är några saker du kan göra i {installationName} för att göra upplevelsen härlig.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Läs våra senaste uppdateringar",
    "ALL_CONVERSATION": {
      "TITLE": "Alla dina konversationer på ett ställe",
      "DESCRIPTION": "Visa alla konversationer från dina kunder i en enda instrumentpanel. Du kan filtrera konversationerna genom inkommande kanal, etikett och status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Bjud in dina teammedlemmar",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Assign to me",
    "TEAM_LABEL": "Assigned Team",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Etiketter för konversation",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Tidigare konversationer",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Väntande",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "Inga attribut hittades",
    "UPDATE": {
      "SUCCESS": "Attribute updated successfully",
      "ERROR": "Unable to update attribute. Please try again later"
    },
    "ADD": {
      "TITLE": "Add",
      "SUCCESS": "Attribute added successfully",
      "ERROR": "Unable to add attribute. Please try again later"
    },
    "DELETE": {
      "SUCCESS": "Attribute deleted successfully",
      "ERROR": "Unable to delete attribute. Please try again later"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Add attributes",
      "PLACEHOLDER": "Sök attribut",
      "NO_RESULT": "Inga attribut hittades"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Från",
    "TO": "Till",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Ämne"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Deltar",
    "SIDEBAR_TITLE": "Deltagare i konversation",
    "NO_RECORDS_FOUND": "Inga resultat hittades",
    "ADD_PARTICIPANTS": "Välj deltagare",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} personer deltar.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person deltar.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Ordernummer",
    "EXTERNAL_ID": "Externt ID",
    "PAYMENT_TYPE": "Betalningsmetod",
    "PAYMENT_DATE": "Betalningsdatum",
    "DELIVERY_PROVIDER": "Transportör",
    "EXPECTED_DATE_OF_DELIVERY": "Förväntad leverans",
    "DATE_OF_DELIVERY": "Levererad",
    "EXPEDITION_DATE": "Avsändningsdatum",
    "INTERNAL_NOTE": "Butiksanteckning",
    "PACKAGE_NUMBER": "Försändelse"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
